import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Share({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12.4714 2.19526C12.211 1.93491 11.7889 1.93491 11.5286 2.19526L6.86189 6.86193L7.8047 7.80474L11.3333 4.27614V13.3333H12.6666V4.27614L16.1952 7.80474L17.138 6.86193L12.4714 2.19526Z"
        fill={iconColor}
      />
      <Path
        d="M5.33329 9.33333C4.9651 9.33333 4.66663 9.63181 4.66663 10V21.3333C4.66663 21.7015 4.9651 22 5.33329 22H18.6666C19.0348 22 19.3333 21.7015 19.3333 21.3333V10C19.3333 9.63181 19.0348 9.33333 18.6666 9.33333H15.3333V10.6667H18V20.6667H5.99996V10.6667H8.66663V9.33333H5.33329Z"
        fill={iconColor}
      />
    </Svg>
  );
}
